import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/assistance";

export default class Assistance extends Page {
  title = "assistance";

  template = templateDefault;

  onAuth() {
    this.refresh();
  }

  onLoad(data) {
    super.onLoad(data);
  }

  onUpdate(prevProps, prevState, snapshot) {
    super.onUpdate(prevProps, prevState, snapshot);

    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.getComponents().findById("assistance").first().setSection();
    }
  }
}
